import {Component, inject, OnInit} from '@angular/core';
import {IonicModule, Platform} from '@ionic/angular';
import {Capacitor} from '@capacitor/core';
import {Keyboard} from '@capacitor/keyboard';
import {SplashScreenManagerService} from './Services/Platform/Capacitor/splash-screen-manager.service';
import {AuthApiService} from './Services/Api/Auth/auth-api.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonicModule],
})
export class AppComponent implements OnInit {

  private readonly platform = inject(Platform);
  private readonly splashScreenManager = inject(SplashScreenManagerService);
  private readonly auth = inject(AuthApiService);

  ngOnInit() {
    this.platform.ready().then(() => {
      this.splashScreenManager.hide()
      this.auth.syncSentryUser();

      this.initKeyboardEvents();
    });
  }


  /**
   * Inicializar los eventos del teclado
   *
   */
  initKeyboardEvents() {

    if (!Capacitor.isNativePlatform()) {
      return;
    }

    Keyboard.addListener('keyboardWillShow', () => {
      document.body.classList.add('keyboard-open');
    });

    Keyboard.addListener('keyboardWillHide', () => {
      setTimeout(() => document.body.classList.remove('keyboard-open'), 250);
    });

  }

}
